import { render, staticRenderFns } from "./format-dialog.vue?vue&type=template&id=402d2a4c&"
import script from "./format-dialog.vue?vue&type=script&lang=js&"
export * from "./format-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports